import {
  BLOCK1_QUESTIONS,
  BLOCK2_QUESTIONS,
  BLOCK3_QUESTIONS,
  Q13_OTHER_ORDER,
  Q23_OTHER_ORIGIN_ORDER,
  type ConsilioAnswers,
  type ScoredQuestionKey,
} from './answers';
import type { TestContext } from 'src/suitability/engine/types';

const allAnswered =
  (questions: readonly ScoredQuestionKey[]) =>
  (answers: ConsilioAnswers): boolean =>
    questions.every((question) => answers[question] !== undefined);

export const hasText = (text?: string): boolean =>
  text !== undefined && text.trim() !== '';

export const isBlock1Complete = allAnswered(BLOCK1_QUESTIONS);

export const isBlock2Complete = (answers: ConsilioAnswers): boolean =>
  allAnswered(BLOCK2_QUESTIONS)(answers) &&
  (answers.q13 !== Q13_OTHER_ORDER || hasText(answers.q13Other));

export const isBlock3Complete = allAnswered(BLOCK3_QUESTIONS);

export const asksForIncomeBracket = (context?: TestContext): boolean =>
  context?.personType !== 'Legal';

export const isAdditionalComplete = (
  answers: ConsilioAnswers,
  context?: TestContext,
): boolean =>
  (!answers.q23?.origins?.includes(Q23_OTHER_ORIGIN_ORDER) ||
    hasText(answers.q23.otherOrigin)) &&
  (!asksForIncomeBracket(context) || answers.q24 !== undefined);
